var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "degreeApplication" }, [
    _c("div", { staticClass: "degreeApplication-box" }, [
      _c("div", { staticClass: "title" }, [_vm._v("成人本科学士学位申报流程")]),
      _c(
        "div",
        { staticClass: "applicationRecord" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.go } },
            [_vm._v("查看申请记录")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabs" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.tabsClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "第一步、自我审查", name: "one" } },
                [_c("SelfExamination")],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "第二步、材料准备", name: "two" } },
                [_c("MaterialScience")],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "第三步、网上申报", name: "three" } },
                [
                  _c("OnlineDeclaration", {
                    on: { submitSuccess: _vm.submitSuccess },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "第四步、材料寄送", name: "four" } },
                [_c("MaterialDelivery")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }